export const Banner = () => (
  <div className="col col-5">
    <div className="login-page__block">
      <div
        className="login-page__img"
        style={{ backgroundImage: "url(images/crm/login.jpg)" }}
      ></div>
    </div>
  </div>
);
